// Fix links that open in a new tab
document.querySelectorAll('a[target="_blank"]').forEach(($link) => {
  $link.setAttribute('rel', 'noopener')
  $link.setAttribute('aria-label', `${$link.textContent} (opens in a new tab)`)
})

const bindActivateOnEnterSpace = ($el) => {
  if ($el.dataset.a11yActivateBound === 'true') return
  $el.dataset.a11yActivateBound = 'true'
  $el.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    // Only activate the host. Inner links/buttons (e.g. READ FULL REVIEW in the
    // press URL carousel) must keep their own Enter/Space behavior.
    if (event.target !== $el) return
    event.preventDefault()
    $el.click()
  })
}

// Tolstoy carousel tiles are focusable divs; ensure they have role="button"
// and keyboard activation (Enter/Space). Inner controls stay out of the tab
// order so we do not nest interactive elements.
const TOLSTOY_NESTED_FOCUSABLE = 'a[href], button, input, select, textarea, video, [tabindex]:not([tabindex="-1"])'
const fixTolstoyCarouselA11y = () => {
  document
    .querySelectorAll('.tolstoy-carousel-video-container[tabindex="0"]:not([role="button"])')
    .forEach(($tile) => {
      $tile.setAttribute('role', 'button')
      bindActivateOnEnterSpace($tile)
    })
}

// Splide nav thumbnails stay role="group" with tabindex="0" in this build.
// Skip slides that already wrap a real control (press URL carousel is
// isNavigation only to stay in sync — the READ FULL REVIEW link is the action).
const fixSplideNavSlideRoles = () => {
  document.querySelectorAll('.splide--nav .splide__slide').forEach(($slide) => {
    const hasInnerControl = Boolean(
      $slide.querySelector('a[href], button, input, select, textarea, [role="link"]')
    )

    if (hasInnerControl) {
      if ($slide.getAttribute('role') === 'button') {
        $slide.setAttribute('role', 'group')
      }
      $slide.removeAttribute('aria-label')
      if ($slide.hasAttribute('tabindex') && $slide.tabIndex >= 0) {
        $slide.tabIndex = -1
      }
      return
    }

    if (!$slide.hasAttribute('tabindex')) return
    if ($slide.getAttribute('role') !== 'button') {
      $slide.setAttribute('role', 'button')
      $slide.removeAttribute('aria-roledescription')
    }
    bindActivateOnEnterSpace($slide)
  })
}

// Okendo media carousel is a focusable landmark; group is the W3C carousel fallback.
const fixOkendoMediaCarouselA11y = () => {
  document.querySelectorAll('.oke-mediaCarousel[tabindex="0"][role="region"]').forEach(($carousel) => {
    $carousel.setAttribute('role', 'group')
  })
}

// Splide sets role="group" (or role="tabpanel" when pagination is on) on slides.
// Neither is valid on <li>.
const fixSplideSlideGroupRoles = () => {
  document.querySelectorAll('li.splide__slide:is([role="group"], [role="tabpanel"])').forEach(($slide) => {
    $slide.removeAttribute('role')
  })
}

const FRONTROW_IFRAME_TITLES = {
  'iframe-modal-testimonials': 'Customer testimonials',
  'iframe-frontrow-testimonials': 'Healthcare provider testimonials',
}

const fixFrontrowIframeTitles = () => {
  document
    .querySelectorAll('iframe.iframe-modal-testimonials, iframe.iframe-frontrow-testimonials')
    .forEach(($iframe) => {
      if ($iframe.getAttribute('title')?.trim()) return
      const className = $iframe.className || ''
      const named = Object.keys(FRONTROW_IFRAME_TITLES).find((cls) => className.includes(cls))
      $iframe.setAttribute('title', named ? FRONTROW_IFRAME_TITLES[named] : 'Frontrow widget')
    })
}

const fixWidgetA11y = () => {
  fixTolstoyCarouselA11y()
  fixSplideNavSlideRoles()
  fixSplideSlideGroupRoles()
  fixFrontrowIframeTitles()
  fixOkendoMediaCarouselA11y()
}

fixWidgetA11y()

let widgetA11yTimer = null
const scheduleWidgetA11yFix = () => {
  clearTimeout(widgetA11yTimer)
  widgetA11yTimer = setTimeout(fixWidgetA11y, 150)
}

new MutationObserver(scheduleWidgetA11yFix).observe(document.body, {
  childList: true,
  subtree: true,
})

// Fix iRESTORE red color

window.toggleHigherContrast = () => {
  const higherContrastSetting = localStorage.getItem('higher-contrast')
  if (higherContrastSetting === 'true') {
    localStorage.setItem('higher-contrast', 'false')
    window.location.reload()
  } else {
    window.setHigherContrast()
  }
}

window.setHigherContrast = () => {
  console.log('Setting higher contrast')

  // This applies an override of the --irestore-red color in the theme.css file
  document.documentElement.classList.add('higher-contrast')

  /*
   Check if the stylesheet is internal or hosted on the current domain.
   If it isn't, attempting to access sheet.cssRules will throw a cross origin error.
   See https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleSheet#Notes

   NOTE: One problem this could raise is hosting stylesheets on a CDN with a
   different domain. Those would be cross origin, so you can't access them.
  */
  const isSameDomain = (styleSheet) => {
    // Internal style blocks won't have an href value
    if (!styleSheet.href) {
      return true
    }

    return styleSheet.href.indexOf(window.location.origin) === 0
  }

  /*
   Determine if the given rule is a CSSStyleRule
   See: https://developer.mozilla.org/en-US/docs/Web/API/CSSRule#Type_constants
  */
  const isStyleRule = (rule) => rule.type === 1

  ;[...document.styleSheets].filter(isSameDomain).forEach((sheet) => {
    ;[...sheet.cssRules].filter(isStyleRule).forEach((rule) => {
      ;[...rule.styleMap.entries()].forEach(([propName, propVal]) => {
        if (propName.indexOf('--') !== 0) return

        if (typeof propVal[0][0] === 'string' && propVal[0][0]?.toUpperCase() === '#F23440') {
          // console.log(rule, propName, propVal);
          rule.styleMap.set(propName, '#DE0D1B')
        } else if (typeof propVal[0][0] === 'string' && propVal[0][0]?.replace(' ', '') === '242,52,64') {
          // console.log(rule, propName, propVal);
          rule.styleMap.set(propName, '222, 13, 27')
        }
      })
    })
  })

  // Set the localStorage value so we can persist the setting
  localStorage.setItem('higher-contrast', 'true')

  const $accessibilityToggle = document.querySelector('#accessibility-toggle')
  if ($accessibilityToggle) {
    $accessibilityToggle.setAttribute('aria-checked', 'true')
  }
}

const higherContrastSetting = localStorage.getItem('higher-contrast')

if (window.matchMedia('(prefers-contrast: high)').matches || higherContrastSetting === 'true') {
  window.setHigherContrast()
}
